import RestService from "@/app/services/RestService.js";

export default class FolderService extends RestService{

    constructor() {
        super('folders', '/')
    }

    addToFolder(chat, folder) {
        const url = `/add-chat-to-folder/${folder.slug}/${chat.slug}`;
        const request = {}
        return this.executePost(url, request)
    }

    removeFromFolder(chat, folder) {
        const url = `/remove-chat-from-folder/${folder.slug}/${chat.slug}`;
        const request = {}
        return this.executePost(url, request)
    }
}
